import React, { useContext, useState } from 'react'
import ApplicationContext from '../../../context/ApplicationContext'
import AutocompleteInput from '../../AutocompleteInput/AutocompleteInput'
import styles from './SearchBox.module.scss'

const SearchBox = () => {
    const [applicationData] = useContext(ApplicationContext)
    const [localizations] = useState(applicationData.localizations)

    return (
        <div className={styles.searchBoxContainer}>
            <h1 className={styles.title}>{localizations.findAFitter}</h1>
            <AutocompleteInput />
        </div>
    )
}

export default SearchBox
